const LogoutIcon = () => {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5826 4.04161L12.3991 5.10965L14.5647 7.0715H6.02836V8.58645H14.5647L12.3991 10.5407L13.5826 11.6163L17.7794 7.82897L13.5826 4.04161ZM2.67091 2.52666H9.38581V1.01172H2.67091C1.74761 1.01172 0.992188 1.69344 0.992188 2.52666V13.1313C0.992188 13.9645 1.74761 14.6462 2.67091 14.6462H9.38581V13.1313H2.67091V2.52666Z"
        fill="#505050"
        stroke="#505050"
        stroke-width="0.5"
      />
    </svg>
  )
}

export default LogoutIcon
